type ExecutePollingProps<T> = {
  intervalMs?: number
  condition: (result: T) => boolean
}

export async function executePolling<T>(
  task: () => Promise<T>,
  { intervalMs, condition }: ExecutePollingProps<T>
): Promise<T> {
  return new Promise((resolve, reject) => {
    function execute() {
      task()
        .then(result => {
          if (condition(result)) {
            return resolve(result)
          }

          setTimeout(execute, intervalMs)
        })
        .catch(reject)
    }
    execute()
  })
}
